import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PlatformLogo } from "@/components/ui/platform-logo";

// Which figure of each platform fills each column, so every number can be
// looked up 1:1 in the platform itself. Keep in step with the connectors
// (ingest/sync_*.py) and ingest/period_reach.py.
const ROWS: { platform: string; name: string; reach: string; impressions: string; engagement: string; video: string }[] = [
  {
    platform: "instagram", name: "Instagram (organisch)",
    reach: "Accounts bereikt (in de app: Kijkers) voor de hele periode. Instagram levert dit voor maximaal 30 dagen; een langere periode wordt geschat (≈) uit exacte vensters van 30 dagen.",
    impressions: "Weergaven (Views), getoond als impressies: Instagram rapporteert geen impressies meer.",
    engagement: "Contentinteracties: likes, reacties, shares, saves en antwoorden.",
    video: "Niet apart: afspelingen zitten in Weergaven.",
  },
  {
    platform: "meta", name: "Meta Ads",
    reach: "Bereik voor de hele periode, ontdubbeld over de campagnes van dezelfde markt en activiteit.",
    impressions: "Impressies.",
    engagement: "Post engagements (Berichtbetrokkenheid). Meta telt hier ook 3-seconden-videoweergaven en linkklikken bij.",
    video: "3-seconden-videoweergaven.",
  },
  {
    platform: "tiktok", name: "TikTok Ads",
    reach: "Bereik voor de hele periode (maximaal 365 dagen).",
    impressions: "Impressies.",
    engagement: "Betaalde likes + betaalde comments + betaalde shares.",
    video: "Videoweergaven (Video views).",
  },
  {
    platform: "linkedin", name: "LinkedIn Ads",
    reach: "Bereik voor de hele periode (LinkedIn: maximaal 92 dagen).",
    impressions: "Impressies.",
    engagement: "Totale engagement (klikken en sociale acties).",
    video: "Weergaven (Views).",
  },
  {
    platform: "reddit", name: "Reddit Ads",
    reach: "Bereik voor de hele periode, in de tijdzone van het account (New York). Per campagne ingedeeld: de conversiecampagne telt bij e-commerce, niet bij awareness.",
    impressions: "Impressies.",
    engagement: "Niet beschikbaar: Reddits API levert geen engagement.",
    video: "3-secondenweergaven (video watched 3 seconds).",
  },
  {
    platform: "google", name: "Google Ads",
    reach: "Impressies, geteld als bereik: Google rapporteert geen uniek bereik over een periode.",
    impressions: "Impressies.",
    engagement: "Niet van toepassing.",
    video: "TrueView-weergaven (Demand Gen / Video).",
  },
  {
    platform: "bing", name: "Microsoft Ads (Bing)",
    reach: "Impressies, geteld als bereik: Microsoft Ads rapporteert geen uniek bereik.",
    impressions: "Impressies.",
    engagement: "Niet van toepassing.",
    video: "Niet van toepassing.",
  },
];

export function AwarenessDefinitions() {
  return (
    <Card className="min-w-0 overflow-hidden">
      <div className="band-header px-5 py-4">
        <h3 className="font-heading text-base font-semibold">Zo telt elk platform</h3>
        <p className="mt-0.5 text-sm text-muted-foreground">
          Bereik telt unieke personen en wordt daarom per periode bij het platform opgevraagd, nooit per dag opgeteld.
          ER = engagement ÷ impressies, over de platformen die engagement leveren (Meta, Instagram, TikTok, LinkedIn).
          Een totaal over platformen, merken of markten is de som van het bereik per platform:
          platformen delen geen gebruikers, dus wie op twee platformen bereikt werd, telt twee keer. Instagram-bereik omvat
          ook gepromote berichten, dus overlapt met Meta Ads.
        </p>
      </div>
      <Table>
        <TableHeader>
          <TableRow className="hover:bg-transparent">
            <TableHead>Platform</TableHead>
            <TableHead>Bereik</TableHead>
            <TableHead>Impressies</TableHead>
            <TableHead>Engagement</TableHead>
            <TableHead>Video views</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {ROWS.map((r) => (
            <TableRow key={r.platform} className="align-top">
              <TableCell className="whitespace-nowrap font-medium">
                <span className="inline-flex items-center gap-2"><PlatformLogo platform={r.platform} size={16} />{r.name}</span>
              </TableCell>
              <TableCell className="min-w-48 whitespace-normal text-xs text-muted-foreground">{r.reach}</TableCell>
              <TableCell className="min-w-40 whitespace-normal text-xs text-muted-foreground">{r.impressions}</TableCell>
              <TableCell className="min-w-48 whitespace-normal text-xs text-muted-foreground">{r.engagement}</TableCell>
              <TableCell className="min-w-36 whitespace-normal text-xs text-muted-foreground">{r.video}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
}
